





































































































































































































































import { mapState } from 'vuex';
import { env } from '@zyf2e/adapt';
import { SPECIALIST, CLINIC_PAYMENT, USER, getIM } from '@/constant';
import { IspecialistDetail, IServicePackListItem, ISpecialPaidPacksItem } from '@/store/specialist/index.d';
import { Dialog, Toast } from '@zyf2e/capui-mobile';
import dayjs from 'dayjs';
import {
  dispatchGetSpecialistDetail,
  dispatchFollowSpecialist,
  dispatchUnfollowSpecialist,
  commitUpdateSpecialistDetail,
  dispatchPlaceOrder,
  dispatchGetSpecialistPacks,
  dispatchGetSpecialistPaidPacks
} from '@/store/specialist';
import { dispatchCheckIMActivity } from '@/store/user';
import Component from 'vue-class-component';
import Webview from '@/webview';
import { tracker } from '@zyf2e/telescope';
import SpecialistPackItem from './components/SpecialistPackItem.vue';

@Component({
  computed: {
    ...mapState(SPECIALIST, ['specialist']),
    ...mapState(USER, ['riskBookAgreed'])
  },
  components: {
    SpecialistPackItem
  }
})
export default class SpecialistDetail extends Webview {
  clinicManual = ['24小时咨询时间', '不限问答次数', '超时退款'];

  specialistSlogan = ['科学管控', '全病程监测', '贴心随访'];

  specialistShowAll = false;

  bottomBtnVisible = false;

  specialistRequest = {
    doctorId: 0,
    areaName: '',
    diagnoseType: 'expert'
  };

  specialist!: IspecialistDetail;

  riskBookAgreed!: boolean;

  isLongText = true;

  hiddenText = true;

  textHeight = 0;

  specialistPacks: IServicePackListItem[] = [];

  specialistPageNo = -1;

  specialistPacksLoading = false;

  specialistPacksFinished = false;

  specialistPaidPacks: ISpecialPaidPacksItem[] = [];

  selectPacksVisible = false;

  selectedEquityPackId = '-1';

  selectedEquityArchiveId = '';

  dayjs = dayjs;

  // eslint-disable-next-line global-require
  defaultSpeicalistAvatar = require('@/assets/default-speicalist-avatar.png');

  env = env;

  observer!: IntersectionObserver;

  get doctorId() {
    const { id } = this.$route.params;
    return id;
  }

  get computeHeight() {
    if (this.textHeight > 105) {
      return this.hiddenText ? 105 : this.textHeight;
    }
    return this.textHeight;
  }

  get specialistPacksGetter() {
    return this.specialistPacks.slice(0, this.specialistShowAll ? this.specialistPacks.length : 3);
  }

  get specialistPaidPacksGetter() {
    return this.specialistPaidPacks.concat({
      userEquityPackId: '0',
      packName: '',
      num: 0,
      residueNum: 0,
      startTime: 0,
      endTime: 0,
      archiveId: '',
      archiveName: ''
    });
  }

  async created() {
    if (!this.doctorId) {
      return;
    }
    this.telescope.trackEvent({ trackId: this.constant.PAGE_DOCTOR_HOME, custom: { id: this.doctorId } });
    await this.getDetail();
    await this.getSpecialPacks();
    const { avatar, jobTitle, department, name, hospital } = this.specialist;
    this.adapter.setTitle(name || '医生主页');
    this.adapter.setShareConfig({
      imageUrl: avatar || this.defaultSpeicalistAvatar,
      title: `${name}-${department}-${jobTitle}`,
      content: hospital,
      link: window.location.href
    });
    this.registFunc({
      type: 'detail',
      func: this.getDetail
    });

    // 服务包卡片曝光埋点
    if (this.specialistPacks && this.specialistPacks.length && !this.env.inWechatMiniProgram) {
      this.telescope.trackPage({
        trackId: 'zyjk-diseasemanage-page-doctor-diseasemanagecard',
        custom: { id: this.doctorId, name: this.specialist.name }
      });
    }
  }

  mounted() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.bottomBtnVisible = !entry.isIntersecting;
      });
    });
    this.observer.observe(document.querySelector('#clinicWrap') as HTMLDivElement);
  }

  beforeDestroy() {
    this.observer.unobserve(document.querySelector('#clinicWrap') as HTMLDivElement);
  }

  async getDetail() {
    this.specialistRequest.doctorId = Number.parseInt(this.doctorId, 0);
    this.specialistRequest.areaName = this.location;
    this.ZYToast.setOnceConfig({ noToast: true });
    await dispatchGetSpecialistDetail(this.$store, this.specialistRequest);
    this.$nextTick(() => {
      try {
        const textH = (this.$refs.overFlowText as HTMLElement).offsetHeight;
        this.textHeight = textH;
        this.isLongText = textH > 105;
      } catch {
        // do nothing
      }
    });
    this.ZYToast.clearOnceConfig();
  }

  async getSpecialPacks() {
    const { servicePackList } = await dispatchGetSpecialistPacks(this.$store, {
      doctorId: Number(this.doctorId),
      pageNo: this.specialistPageNo + 1,
      pageSize: 20
    });
    this.specialistPacksLoading = false;
    this.specialistPageNo += 1;
    this.specialistPacks.push(...servicePackList);
    this.specialistPacksFinished = servicePackList.length < 20;
  }

  async getSpecialistPaidPacks() {
    const { list } = await dispatchGetSpecialistPaidPacks(this.$store, {
      doctorId: Number(this.doctorId),
      equityItem: 'EXPERT_INQUIRY'
    });
    this.specialistPaidPacks = list;
  }

  async followSpecialist() {
    const { followed } = this.specialist as IspecialistDetail;
    let continueFollow: boolean;

    let trackId = this.constant.CLICK_EXPERT_DOCTOR_HOME_UNSUBSCRIBE;

    const { doctorId } = this.specialistRequest;

    if (followed) {
      try {
        await Dialog.confirm({
          title: '取消关注',
          message: '是否取消对该医生对关注？'
        });
        await dispatchUnfollowSpecialist(this.$store, { doctorId });
        continueFollow = false;
      } catch (err) {
        return;
      }
    } else {
      trackId = this.constant.CLICK_EXPERT_DOCTOR_HOME_ATTENTION;
      try {
        const res = await dispatchFollowSpecialist(this.$store, { doctorId, force: false });
        if (res.success) {
          continueFollow = true;
        } else if (res.isConflict) {
          await Dialog.confirm({
            title: '系统提示',
            confirmButtonText: '仍要关注',
            message: `为给您提供更专业、专属的服务，建议每个科室仅关注一位医生，如需关注该医生，将取消现有医生的关注关系，是否仍要关注 ${this.specialist.name} 医生`
          });

          await dispatchFollowSpecialist(this.$store, { doctorId, force: true });
          continueFollow = true;
        } else {
          Toast.fail('关注失败');
          continueFollow = false;
        }
        this.ZYToast.clearOnceConfig();
      } catch (e) {
        return;
      }
    }

    this.telescope.trackEvent({ trackId });

    commitUpdateSpecialistDetail(this.$store, { followed: continueFollow });
  }

  choosePaidPackItem(item: ISpecialPaidPacksItem) {
    this.selectedEquityPackId = item.userEquityPackId;
    this.selectedEquityArchiveId = item.archiveId;
  }

  @tracker('zyjk-click-guide-perfect-information-determine')
  async toPay(trackId: string) {
    const channel = sessionStorage.getItem('channel');
    if (channel) this.$set(this.specialistRequest, 'channel', channel);
    const { consultService, price, memberFree, firstConsultFree, coin } = this.specialist;
    if (!consultService) {
      return;
    }

    const isFree = memberFree || firstConsultFree || (!price && !coin);
    // 在小程序环境下，非免费问诊需要提示下载App
    // if (env.inWechatMiniProgram) {
    //   const toastMsg = '请前往智云健康APP进行在线问诊';
    //   if (!isFree) {
    //     this.$toast(toastMsg);
    //     return;
    //   }
    // }

    this.telescope.trackEvent({ trackId });

    this.ZYToast.setOnceConfig({ noToast: true });
    // this.$toast.loading({ duration: 0 });

    const { doctorId: id } = this.specialistRequest;
    try {
      const { allow, consultId } = await dispatchCheckIMActivity(this.$store, { toId: id });
      // 若有正在进行中的图文咨询则直接进入IM。
      if (allow) {
        this.$toast.clear(true);
        this.ZYToast.clearOnceConfig();
        this.adapter.goIM({ toId: id.toString() });
        // window.location.href = getIM(id);
        return;
      }

      // 若有未支付的订单，则进入页面后显示原订单价格，进行支付
      if (consultId) {
        this.goPaymentPage(id);
        return;
      }

      // 判断当前问诊是否免费或者有免费次数，若有则创建免费订单或扣减免费次数
      if (isFree) {
        await dispatchPlaceOrder(this.$store, this.specialistRequest);
        this.goPaymentPage(id);
        return;
      }

      // 获取当前用户对该医生可使用的专家问诊权益包列表
      await this.getSpecialistPaidPacks();

      // 若不免费或无免费次数，则判断是否有该医生可以使用的专病服务包权益 & 不在微信小程序环境打开(小程序隐藏专病入口)
      if (this.specialistPaidPacks.length && !env.inWechatMiniProgram) {
        this.selectPacksVisible = true;
        return;
      }

      // 该医生无可用专病服务包，按正常流程进入下一步
      await dispatchPlaceOrder(this.$store, this.specialistRequest);
      this.goPaymentPage(id);
    } catch ({ code, message }) {
      if (code === 'VIP_MEMBER_DOCTOR' || code === 'NOT_IN_MEMBER_DOCTOR' || code === 'MEMBER_NO_ADVISORY_EQUITY') {
        await Dialog.alert({ title: '提示', message, confirmButtonText: '好的' });
      } else {
        this.$toast.fail(message);
      }
    }

    this.$toast.clear(true);
    this.ZYToast.clearOnceConfig();
  }

  goPaymentPage(doctorId: number) {
    // TODO 创建订单在这一步，跳转下单页面用replace， 若今后创建订单在下单页面此处改为push
    this.$router.replace({
      name: CLINIC_PAYMENT,
      params: { id: doctorId.toString() }
    });
  }

  async toEquityPackPay() {
    if (+this.selectedEquityPackId < 0) {
      this.$toast('您已购买该医生的专家服务，请选择是否使用');
      return;
    }

    // 勾选不使用权益，则点击提交后，创建订单，走正常支付流程
    if (this.selectedEquityPackId === '0') {
      await dispatchPlaceOrder(this.$store, this.specialistRequest);
      this.goPaymentPage(Number(this.doctorId));
      return;
    }
    await dispatchPlaceOrder(this.$store, {
      ...this.specialistRequest,
      sourceId: String(this.selectedEquityPackId),
      archiveId: this.selectedEquityArchiveId
    });
    // 清空选中数据
    this.selectedEquityPackId = '-1';
    this.selectedEquityArchiveId = '';
    this.selectPacksVisible = false;
    this.goPaymentPage(Number(this.doctorId));
  }
}
